<script lang="ts">
    import IdManager from "../tools/IdManager";
    import Block, { BlockTypes } from "./Block";
    import { getPreviewBlocks } from "./Parser";

    export let screenplay: string;
    export let projectId: string;

    const blocks = getPreviewBlocks(screenplay, new IdManager(".Block"));
    const pages: Block[][] = [];
    let currentPage: Block[] = [];
    let i = 0;
    for (const block of blocks) {
        if (i > 55 || block.getType() === BlockTypes.PageBreak) {
            if (currentPage.length > 0) {
                pages.push([...currentPage]);
                currentPage = [];
            }
            i = 0;
        }

        if (block.getType() !== BlockTypes.PageBreak) {
            let numberOfLines = Math.ceil(block.getText().length / 61);
            if (block.getType() === BlockTypes.Dialogue) {
                numberOfLines = Math.ceil(block.getText().length / 36);
            }
            if (block.getType() === BlockTypes.Character) {
                numberOfLines = 1;
            }

            if (numberOfLines === 0) {
                numberOfLines = 1;
            }

            currentPage.push(block);
            i += numberOfLines;
        }
    }

    if (currentPage.length > 0) {
        pages.push([...currentPage]);
    }
</script>

<div class="ScreenplayPreview">
    {#each pages as page}
        <div class="Page">
            {#each page as block (block.getId())}
                <div
                    class={block.getClassNames().join(" ")}
                    data-id={block.getId()}
                >
                    {@html block.renderPreviewHTML(projectId)}
                </div>
            {/each}
        </div>
    {/each}
</div>

<style type="text/scss">
    .Page {
        width: 8.5in;
        padding: 1in 1in 1in 1.5in;
        box-sizing: border-box;
        border: 1px solid #333;
        margin: 20px auto;
        min-height: 11in;
    }
    .ScreenplayPreview {
        font-family: "courier_primeregular", "Courier New", Courier, monospace;
        box-sizing: border-box;
        font-size: 12pt;
        outline: none;
        line-height: 18px;
        letter-spacing: -0.3px;
        :global(.Block) {
            min-height: 18px;
            box-sizing: content-box;
        }
        :global(.Block--scene-heading) {
            text-transform: uppercase;
            font-weight: bold;
        }

        :global(.Block--character) {
            padding-left: 1.7in;
        }

        :global(.Block--dialogue) {
            padding-left: 1in;
            max-width: 3.5in;
        }
        :global(.Block--parenthetical) {
            padding-left: 1.1in;
        }

        :global(.Block--centered-action) {
            text-align: center;
        }

        :global(.Block--transition) {
            text-align: right;
        }

        :global(.Block--lyrics) {
            text-align: center;
            padding: 0 10%;
        }

        :global(.emphasis--bold) {
            font-weight: bold;
        }
        :global(.emphasis--italics) {
            font-style: italic;
        }
        :global(.emphasis--underline) {
            text-decoration: underline;
        }
        :global(.Block--image img) {
          max-width: 100%;
        }
    }
</style>
